import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';

export default function FloatingActions() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const MSG = "Hello Laxmi Printers Team,\n\nI visited your website and I am interested in your premium printing and customized bag services.\n\nPlease share the following details:\n- Product Catalogue\n- Pricing Details\n- Minimum Order Quantity (MOQ)\n- Printing Options Available\n- Delivery Timelines\n\nThank You.";
  const openWA = () => {
    window.open(`https://wa.me/916302362758?text=${encodeURIComponent(MSG)}`, '_blank');
  };

  return (
    <>
      <style>{`
        @keyframes floatUpDown {
          0% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
          100% { transform: translateY(0); }
        }
        @keyframes fadeSlide { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        .wa-float-btn {
          animation: fadeSlide 0.4s ease, floatUpDown 3s ease-in-out infinite;
        }
        .wa-float-btn:hover {
          transform: scale(1.1) !important;
          box-shadow: 0 12px 32px rgba(37,211,102,0.6) !important;
          animation-play-state: paused;
        }
        @media(max-width:600px){
          .wa-float-btn { bottom: 24px !important; right: 24px !important; width: 52px !important; height: 52px !important; }
        }
      `}</style>

      {show && (
        <button
          className="wa-float-btn"
          style={s.waBtn}
          onClick={openWA}
          title="Chat with us on WhatsApp"
        >
          <FaWhatsapp style={{ fontSize: 32 }} />
        </button>
      )}
    </>
  );
}

const s = {
  waBtn: {
    position: 'fixed', bottom: 32, right: 32, zIndex: 99998,
    width: 60, height: 60, borderRadius: '50%',
    background: 'linear-gradient(135deg, #25D366, #128C7E)',
    color: '#fff', border: 'none', cursor: 'pointer',
    boxShadow: '0 8px 24px rgba(37,211,102,0.4)',
    transition: 'all 0.3s ease',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
};
